import { OtoIndividualPlacementFilters } from '../../types/models/enrollment/oto-individual-enrollments'

export const transformOtoIndividualPlacementFiltersToUrl = (
  filters?: OtoIndividualPlacementFilters
): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.country) searchParams.append('country', filters.country)
  if (filters.journeyPlaceId)
    searchParams.append('journeyPlaceId', filters.journeyPlaceId.toString())
  if (filters.arrivalPlaceId)
    searchParams.append('arrivalPlaceId', filters.arrivalPlaceId.toString())
  if (filters.numberOfHours) searchParams.append('numberOfHours', filters.numberOfHours.toString())
  if (filters.numberOfWeeks) searchParams.append('numberOfWeeks', filters.numberOfWeeks.toString())
  if (filters.departureDate) searchParams.append('departureDate', filters.departureDate)
  if (filters.returnDate) searchParams.append('returnDate', filters.returnDate)

  return searchParams.toString()
}

export const transformUrlToOtoIndividualPlacementFilters = (
  searchParams: URLSearchParams
): OtoIndividualPlacementFilters => {
  const filters: OtoIndividualPlacementFilters = {}

  const country = searchParams.get('country')
  if (country) filters.country = country

  const journeyPlaceId = searchParams.get('journeyPlaceId')
  if (journeyPlaceId) filters.journeyPlaceId = +journeyPlaceId

  const arrivalPlaceId = searchParams.get('arrivalPlaceId')
  if (arrivalPlaceId) filters.arrivalPlaceId = +arrivalPlaceId

  const numberOfHours = searchParams.get('numberOfHours')
  if (numberOfHours) filters.numberOfHours = +numberOfHours

  const numberOfWeeks = searchParams.get('numberOfWeeks')
  if (numberOfWeeks) filters.numberOfWeeks = +numberOfWeeks

  const departureDate = searchParams.get('departureDate')
  if (departureDate) filters.departureDate = departureDate

  const returnDate = searchParams.get('returnDate')
  if (returnDate) filters.returnDate = returnDate

  return filters
}
